import LanguagePack from "../../../../../shared/lib/html5-software-library/src/ranj/language/LanguagePack";
import AppModel from "../../../../../shared/src/ranj/app/core/AppModel";
import GameModel from "../core/model/GameModel";
import AbstractCollaborationScreenMediator from "../core/view/AbstractCollaborationScreenMediator";

export default class TransitionScreenMediator extends AbstractCollaborationScreenMediator {

    /**
     * 
     * @param {createjs.DisplayObject} target 
     * @param {soma.EventDispatcher} dispatcher 
     * @param {LanguagePack} languagePack 
     * @param {*} layoutManager 
     * @param {*} soundManager 
     * @param {*} gameAssets 
     * @param {AppModel} appModel 
     * @param {GameModel} gameModel 
     */
    constructor(target, dispatcher, languagePack, layoutManager, soundManager, gameAssets, gameModel, gameConfig, mediatorManager) {
        super(target, dispatcher, languagePack, layoutManager, soundManager, gameAssets, gameModel, mediatorManager);
        this._gameConfig = gameConfig;
    }

    initialize() {
        super.initialize();

        const { description } = this._target.parameters;
        this._onClose = this._target.onClose;

        this._target.titleTextfield.text = description;
        
        const bitmap = this._target.children.find(c => c instanceof createjs.Bitmap);
        this._elementsToAnimate = [
            this._target.bg,
            bitmap,
            this._target.titleTextfield,
        ];
        this._elementsToAnimate.forEach(elem => elem.alpha = 0);

        this._playTransition();
    }

    destroy() {
        super.destroy();
    }

    _animateIn() {
        let delay = 0;
        this._elementsToAnimate.forEach(elem => {
            elem.visible = true;
            createjs.Tween.get(elem)
                .wait((delay += 250) / this._speedFactor)
                .to({ alpha: 1 }, 250 / this._speedFactor, createjs.Ease.quadOut);
        });
    }

    _animateOut() {
        const dur = 250;
        let delay = 0;
        [... this._elementsToAnimate].reverse().forEach(elem => {
            createjs.Tween.get(elem)
                .wait((delay += 250) / this._speedFactor)
                .to({ alpha: 0 }, dur / this._speedFactor, createjs.Ease.quadIn);
        });
        this._onClose();
        this.callDelayed(() => {
            this.closePopup(this._target);
        }, (delay + dur) / this._speedFactor);
    }

    _playTransition() {
        this._animateIn();
        const startDelay = this._gameConfig.getValue("transition.duration");
        this.callDelayed(this._animateOut.bind(this), startDelay / this._speedFactor);
    }
}
